<div style="width: 100%;">
  <div fxLayout="row" fxLayoutAlign="center center" style="padding:20px 0px;" *ngIf="banderaSelect">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
        <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.SELECT' | translate}}</mat-label>
        <mat-select #selectBandera>
          <mat-option [value]="0">
            Excel
          </mat-option>
          <mat-option [value]="1">
            Survey
          </mat-option>
          <mat-option [value]="2">
            Ambos
          </mat-option>
        </mat-select>
        <mat-error></mat-error>
    </mat-form-field>
    <button mat-fab color="primary" aria-label="agregaPreg" (click)="setBanderaDemograficos(selectBandera.value)">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <!--
<h2 style="text-align:center;">{{'CERTIFICAR.FORALL.AGREGADEMOGRAFICO' | translate}}</h2>     *ngIf="banderaSelect"-->
  <div fxLayout="row" fxLayoutAlign="center center" style="padding:20px 0px;">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
        <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.SELECT' | translate}}</mat-label>
        <mat-select #selectCatalogo>
          <mat-option *ngFor="let demo of catalogo" [value]="demo.clave">
            {{demo.clave}}
          </mat-option>
        </mat-select>
        <mat-error></mat-error>
    </mat-form-field>
    <button mat-fab color="primary" aria-label="agregaPreg" (click)="addDemografico(selectCatalogo.value)">
      <mat-icon>add</mat-icon>
    </button>
  </div>


    <div fxLayoutAlign="center center" style="width: 100%;">

      <div class="p-20" style="width: 100%;">

          <div>

               <ng-container *ngFor="let pregunta of preguntas; let i = index; let last = last; let first = first;">
                  <div >
                      <mat-icon aria-hidden="false" class="mr-20" matTooltip="" style="display:none" >menu</mat-icon>

                      <mat-expansion-panel class="mb-20">
                          <mat-expansion-panel-header class="accent-100" >
                              <mat-panel-title>
                                  {{ pregunta.clave }}
                              </mat-panel-title>
                              <mat-panel-description>
                                  {{'CERTIFICAR.DEMOGRAFICOS.CONFIGURE_QUESTION' | translate}}
                              </mat-panel-description>
                          </mat-expansion-panel-header>

                          <p>{{'CERTIFICAR.DEMOGRAFICOS.QUESTION' | translate}}</p>
                          <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20">

                            <mat-form-field class="input" appearance="outline" fxFlex="50">
                                <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.QUESTION' | translate}}</mat-label>
                                <textarea matInput required [value]="pregunta.preguntaDemografico" (blur)="onBlurPregunta($event,pregunta);"></textarea>
                                <mat-error>Error, complete la pregunta</mat-error>
                            </mat-form-field>

                              <button *ngIf="pregunta.obligatorio != 1" mat-icon-button aria-label="borraPreg" (click)="deleteDemografico(pregunta._id)"
                              matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.TOOLTIP.REMOVE' | translate}}">
                                <mat-icon class="s-40">delete_forever</mat-icon>
                              </button>

                          </div>

                          <p>{{'CERTIFICAR.DEMOGRAFICOS.OPCIONES_RESPUESTA' | translate}}</p>
                          <div fxLayout="row" fxLayoutAlign="space-between center">
                            <h3>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.OPCIONES.TITU' | translate}}</h3>
                            <button mat-mini-fab color="primary" aria-label="agregaOpc" *ngIf="!pasoCompleto"
                              matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TOOLTIP.ADD' | translate}}" (click)="addResponse(pregunta.clave)">
                              <mat-icon>add</mat-icon>
                            </button>
                          </div>
                          <div fxLayout="row" fxLayoutAlign="center" >
                              <div cdkDropList (cdkDropListDropped)="drop($event,pregunta._id)" fxLayout="column" style="width: 100%;">

                                   <div *ngFor="let opcion of pregunta.opciones; index as i;" class="opcionResp" cdkDrag >
                                      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>

                                      <mat-icon aria-hidden="false" class="mr-20" matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TOOLTIP.MOVE' | translate}}" cdkDragHandle>menu</mat-icon>

                                      <mat-form-field class="input" appearance="outline">
                                          <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.OPCIONES_RESPUESTA' | translate}}</mat-label>
                                          <textarea matInput required [value]="opcion.textoOpcion" (blur)="onBlurRespuesta($event,opcion,pregunta._id);"></textarea>
                                          <mat-error>Error, complete la opcion de respuesta</mat-error>
                                      </mat-form-field>
                                  </div>

                              </div>
                          </div>

                          <div>

                          </div>

                      </mat-expansion-panel>

                  </div>
              </ng-container>

          </div>
          <!------------------------>

          <hr>



      </div>
    </div>


</div>
